import React, { useState, useEffect, useCallback } from "react";
import { Typography, Button, Skeleton } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { useHistory } from "react-router-dom";
import { SubscriptionsAPI } from "api_inbusiness";
import styles from "./SubscriptionUpsell.module.scss";

const SubscriptionUpsell = () => {
  const history = useHistory();
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(true);

  const getPlans = useCallback(async () => {
    try {
      const res = await SubscriptionsAPI.getPublic();
      if (res.ok && res.data?.content) {
        setPlans(res.data.content);
      }
    } catch (error) {
      console.error("Failed to load plans:", error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    getPlans();
  }, [getPlans]);

  const handleJoinClub = () => {
    history.push("/becomeMember");
  };

  const benefits = [
    "Acces la întâlnirile InBusiness",
    "Networking cu antreprenori locali",
    "Sesiuni de mastermind",
    "Materiale educaționale exclusive",
  ];

  // Find the minimum price from plans
  const getMinPrice = () => {
    if (!plans || plans.length === 0) return 99; // fallback
    const monthlyPlan = plans.find(p => p.recurrence === 'MONTHLY');
    return monthlyPlan ? Math.round(monthlyPlan.price) : Math.round(plans[0].price);
  };

  if (loading) {
    return (
      <div className={styles.upsellCard}>
        <Skeleton variant="text" width="60%" height={28} />
        <Skeleton variant="text" width="80%" height={20} />
        <Skeleton variant="rectangular" height={120} sx={{ mt: 2, borderRadius: 2 }} />
        <Skeleton variant="rectangular" height={44} sx={{ mt: 2, borderRadius: 2 }} />
      </div>
    );
  }

  return (
    <div className={styles.upsellCard}>
      <div className={styles.header}>
        <Typography variant="h6" className={styles.title}>
          Devino Membru
        </Typography>
        <Typography variant="body2" className={styles.subtitle}>
          Accesează toate beneficiile clubului
        </Typography>
      </div>

      <ul className={styles.benefitsList}>
        {benefits.map((benefit, index) => (
          <li key={index} className={styles.benefitItem}>
            <CheckCircleOutlineIcon className={styles.checkIcon} />
            <span>{benefit}</span>
          </li>
        ))}
      </ul>

      <div className={styles.pricing}>
        <span className={styles.from}>de la</span>
        <span className={styles.price}>{getMinPrice()}</span>
        <span className={styles.currency}>lei/lună</span>
      </div>

      <Button
        variant="contained"
        fullWidth
        className={styles.ctaButton}
        onClick={handleJoinClub}
        endIcon={<ArrowForwardIcon />}
      >
        Vezi Planurile
      </Button>
    </div>
  );
};

export default SubscriptionUpsell;
